"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEtherscanApiKey = void 0;
function getEtherscanApiKey(network, chain) {
    var _a;
    return (_a = process.env[`ETHERSCAN_${chain.toUpperCase()}_API_KEY`]) !== null && _a !== void 0 ? _a : '';
}
exports.getEtherscanApiKey = getEtherscanApiKey;
